import { useState, useEffect, useRef } from 'react';
import { Button, Input, Row, Col, Menu } from 'antd';
import './App.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import DEFAULT_EXIST_APP, { CHT_DEFAULT_EXIST_APP } from './init';
import i18n from './init-i18n';


const LOCAL_URL = 'http://localhost:10086'

function App() {
  const [appList, setAppList] = useState([]);
  const [searchHistory, setSearchHistory] = useState([]);
  const [suggesstions, setSuggesstions] = useState([]);
  const [text, setText] = useState<string>('');
  const [activeTab, setActiveTab] = useState(0);
  const defaultConfig = localStorage.getItem('systemLanguage') == 'zh' ? {
    key: '360',
    title: '360搜索',
    fullTitle: '360搜索，SO靠谱',
    favicon: 'https://ss.360tres.com/static/121a1737750aa53d.ico',
    url: 'https://www.so.com/',
    enabled: true,
    urlParams: 'https://www.so.com/s?q='
  } : {
    key: 'google',
    title: 'Google',
    fullTitle: 'Google',
    favicon: 'https://i-blog.csdnimg.cn/blog_migrate/7f7f215b09c7888ee71d38f6ec4cf26f.png',
    url: 'https://www.google.com/',
    enabled: false,
    urlParams: 'https://www.google.com/search?q='
  }
  const [defaultSearchEngine, setDefaultSearchEngine] = useState<any>(defaultConfig);
  const [history, setHistory] = useState<any>([]);
  const cardListRef = useRef(null);
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  // system language
  const [appLanguage, setAppLanguage] = useState<string>('zh');
  const [isPhancy, setIsPhancy] = useState<boolean>(false);
  const { t, i18n } = useTranslation('translation', { lng: appLanguage });

  const handleClick = (url: string) => {
    window.open(url)
  }

  const handleSearch = (e: any) => {
    const value = e.target.value;
    let fullUrl: string;
    const urlRegex = /^(https?:\/\/)((([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}|localhost)|(\d{1,3}\.){3}\d{1,3})(:\d+)?(\/.*)?$/;
    if (urlRegex.test(value)) {
      fullUrl = value;
    } else {
      const wwwRegex = /(([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}|localhost)|(\d{1,3}\.){3}\d{1,3}(:\d+)?(\/.*)?$/
      if (wwwRegex.test(value)) {
        fullUrl = `https://${value}`
      } else {
        fullUrl = defaultSearchEngine.urlParams + value;
      }
    }

    window.open(fullUrl)
    // add
    axios.post(`${LOCAL_URL}/search_history`, {
      text,
      fullUrl
    }).then((res) => {
      // @ts-ignore
      setSearchHistory([...handleHistoryData(res.data)])
    })
  }

  const handleSuggestion = (value: string) => {
    console.log('handleSuggestion', value)
    setText(value);
    if (!value) return;
    let suggesstions: any = []
    history.forEach((his: any) => {
      if (his.title.includes(value) || his.url.includes(value)) {
        suggesstions.push(his)
      }
    })
    suggesstions.sort((a: any, b: any) => b.createDate - a.createDate);
    suggesstions = suggesstions.slice(0, 10);
    setSuggesstions(suggesstions.map((sug: any) => {
      return {
        id: sug.id,
        label: sug.title + ' - ' + sug.url,
        key: sug.url,
        icon: sug.favicon ? <img src={sug.favicon} alt={sug.title} width={24} /> : ''
      }
    }))
  }

  const handleActiveLabel = (label: string, cate_index: number) => {
    setActiveTab(cate_index)
  }

  const handleInstall = (e: any, card: any) => {
    e.stopPropagation()
    try {
      // @ts-ignore
      if (phancy) {
        // add to local
        const existSidebarList = JSON.parse(localStorage.getItem('sidebar_list'));
        existSidebarList.push(card);
        localStorage.setItem('sidebar_list', JSON.stringify(existSidebarList));
        // @ts-ignore
        phancy?.sidebar.updateAppList(JSON.stringify(existSidebarList))

        setAppList([...updateStatusByUrls(existSidebarList.map((i: any) => i.url), appList)])
      }
    } catch (error) {
      axios.get(`${LOCAL_URL}/install/${card.id}`).then((res) => {
        console.log('11111', res)
        let existUrlList = []
        const existlist = res.data;
        existUrlList = existlist.map((i: any) => i.url);
        console.log('existUrlList', existUrlList)
        // @ts-ignore
        setAppList([...updateStatusByUrls(existUrlList, appList)])
      })
    }
  }

  const updateStatusByUrls = (urlList: any, categories: any) => {
    if (urlList.length === 0) return;
    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      for (let j = 0; j < category.cards.length; j++) {
        const card = category.cards[j];
        if (urlList.includes(card.url)) {
          card.status = 'done';
        } else {
          card.status = 'pending';
        }
      }
    }
    return categories
  }

  const deleteHistory = (id: string) => {
    console.log('deleteHistory', id)

    axios.delete(`${LOCAL_URL}/search/${id}`).then((res) => {
      // @ts-ignore
      setSearchHistory([...handleHistoryData(res.data)])
    })
  }

  const handleHistoryData = (resData: any) => {
    return resData.map((history: any) => {
      return {
        label: history.text,
        key: history.text,
        icon: '',
        extra: <div onClick={(e) => {
          e.stopPropagation()
          deleteHistory(history.id)
        }}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="browser-ui/cross-solid" opacity="0.8" clip-path="url(#clip0_6_95)">
              <path id="Vector" d="M8.27694 8.4L12 4.67692L11.3231 4L7.60001 7.72308L3.87694 4L3.20001 4.67692L6.92309 8.4L3.20001 12.1231L3.87694 12.8L7.60001 9.07692L11.3231 12.8L12 12.1231L8.27694 8.4Z" fill="black" />
            </g>
            <defs>
              <clipPath id="clip0_6_95">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      }
    });
  }

  useEffect(() => {
    // init event
    // @ts-ignore
    const scrollToTab = () => {
      if (cardListRef.current) {
        // @ts-ignore
        const cardElements = cardListRef.current.children;

        if (activeTab < cardElements.length) {
          const targetElement = cardElements[activeTab];
          const titleElement = targetElement.querySelector('.title');
          titleElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
    scrollToTab();
  }, [activeTab]);

  useEffect(() => {
    try {
      // @ts-ignore
      phancy?.sidebar.regOnRequestAppListHandler(() => {
        console.log('registry success')
      })
      // @ts-ignore
      phancy.history.regOnRequestHistoryListHandler((history) => {
        console.log('history', history)
        if (history) {
          setHistory(JSON.parse(history))
        }
      })
    } catch (error) {
      console.log('error', error)
    }
    let localAppLanguage: string = localStorage.getItem('systemLanguage') || 'zh';
    const langMap:any = {
      'cht': 'zh-tw',
      'jp': 'ja',
      'vie': 'vi',
      'kor': 'ko',
    }
    setAppLanguage(localAppLanguage)
    document.title = (localAppLanguage == 'zh' ? '首页' : 'Home Page');

    let url: string = 'https://super-app.iwhop.cn/wearfitApp/api/v1/browserFunction/getBrowserFunction'
    try {
      // @ts-ignore
      if (phancy) url = 'https://test-ai-howear.iwhop.cn/wearfitApp/api/v1/browserFunction/getBrowserFunction'
      setIsPhancy(true);
    } catch (error) {

    }
    if (localStorage.getItem('systemLanguage') == 'cht') {
      url = 'https://super-app.iwhop.com/wearfitApp/api/v1/browserFunction/getBrowserFunction'
    }
    axios.get(url, {
      // axios.get('https://super-app.iwhop.cn/wearfitApp/api/v1/browserFunction/getBrowserFunction', {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': langMap[localAppLanguage] || localAppLanguage,
      },
    }).then((res: any) => {
      try {
        // @ts-ignore
        console.log('history', phancy.history.requestHistoryList())
        // if local exist
        if (localStorage.getItem('sidebar_list')) {
          let existSidebarList = JSON.parse(localStorage.getItem('sidebar_list'));

          // TODO: update url
          let appListUpdated = false;
          existSidebarList.forEach(element => {
            DEFAULT_EXIST_APP.forEach((item, index) => {
              if (item.id === element.id) {
                if (item.url !== element.url ) {
                  element.url = item.url;
                  appListUpdated = true;
                }
              }
            })
          });
          if (appListUpdated) {
            localStorage.setItem('sidebar_list', JSON.stringify(existSidebarList));
          }

          // @ts-ignore
          phancy?.sidebar.updateAppList(JSON.stringify(existSidebarList))
          setAppList(updateStatusByUrls(existSidebarList.map((i: any) => i.url), res.data.categories))
        } else {
          // @ts-ignore
          phancy?.sidebar.updateAppList(JSON.stringify(DEFAULT_EXIST_APP))
          localStorage.setItem('sidebar_list', JSON.stringify(DEFAULT_EXIST_APP));
          setAppList(updateStatusByUrls(DEFAULT_EXIST_APP.map((i: any) => i.url), res.data.categories))
        }
        // @ts-ignore
        phancy.sidebar.regOnRemoveAppHandler((app) => {
          const parseApp = JSON.parse(app.replace('id', '"id"'))
          console.log(parseApp.id);
          // add to local
          const existSidebarList = JSON.parse(localStorage.getItem('sidebar_list'));
          const updateSidebarList = existSidebarList.filter((item) => item.id !== parseApp.id);
          localStorage.setItem('sidebar_list', JSON.stringify(updateSidebarList));
          // @ts-ignore
          phancy?.sidebar.updateAppList(JSON.stringify(updateSidebarList))
          setAppList(updateStatusByUrls(updateSidebarList.map((i: any) => i.url), res.data.categories))
        })
      } catch (error) {
        axios.get(`${LOCAL_URL}/existing_app_list`).then((existRes) => {
          let existUrlList = []
          const existlist = existRes.data;
          existUrlList = existlist.map((i: any) => i.url);
          const list = localStorage.getItem('systemLanguage') == 'cht' ? CHT_DEFAULT_EXIST_APP : res.data.categories;
          console.log(appLanguage, list)
          setAppList(updateStatusByUrls(existUrlList, list))
        }).catch(() => {
          setAppList(res.data.categories)
        })
        // fetch searchhistory
        axios.get(`${LOCAL_URL}/search_history_list`).then((res) => {
          // eslint-disable-next-line
          setSearchHistory(handleHistoryData(res.data))
        })

        // fetch default search engine
        axios.get(`${LOCAL_URL}/default_search_engine`).then((res) => {
          setDefaultSearchEngine(res.data);
        })

        // fetch search history
        axios.get(`${LOCAL_URL}/history`).then((res) => {
          setHistory(res.data);
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [])

  const onClick = (e: any) => {
    console.log('click ', e.key);
    window.open(e.key.includes('http') ? e.key : defaultSearchEngine.urlParams + e.key)
  };

  const lastMenuList = text ? suggesstions : searchHistory;

  return (
    <div className="App">
      <div className='header' onClick={(e: any) => {
        if (e.target.classList.contains('header')) setMenuVisible(false)
        try {
          // @ts-ignore
          if (phancy) console.log('phancy')
        } catch (error) {
          // fetch search history
          axios.get(`${LOCAL_URL}/history`).then((res) => {
            setHistory(res.data);
          })
          // fetch searchhistory
          axios.get(`${LOCAL_URL}/search_history_list`).then((res) => {
            // eslint-disable-next-line
            setSearchHistory(handleHistoryData(res.data))
          })
        }
      }}>
        <Input
          onPressEnter={(value) => handleSearch(value)}
          onChange={(e) => handleSuggestion(e.target.value)}
          onFocus={(e) => {
            e.stopPropagation()
            setMenuVisible(true)
          }} prefix={<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Interface, Essential/Search, Loupe">
              <g id="Group">
                <g id="search">
                  <path id="Path" d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path id="Path_2" d="M19 19L15.71 15.71" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
              </g>
            </g>
          </svg>
          } placeholder={t('搜索或输入网址')} />
        {menuVisible && lastMenuList.length !== 0 &&
          <Menu
            onClick={onClick}
            mode="vertical"
            items={text ? suggesstions : searchHistory}
          />}
        {
          isPhancy &&
          <div className='tabs' onClick={() => setMenuVisible(false)}>
            {appList.map((cate: any, cate_index) => <div onClick={() => handleActiveLabel(cate.label, cate_index)} className={`tab ${cate_index === activeTab ? 'active' : ''}`}>{cate.label}</div>)}
          </div>
        }
      </div>
      <div className='container' style={{
        top: isPhancy ? '237px' : '160px',
        height: isPhancy ? 'calc(100% - 234px)' : 'calc(100% - 134px)'
      }} onClick={() => setMenuVisible(false)}>
        <div className='card-list' ref={cardListRef}>
          {
             appList.map((cate: any, c_idx: number) => {
              return <div key={c_idx}>
                <h3 className='title'>{cate.label}</h3>
                <Row gutter={[16, 16]}>
                  {
                    cate.cards.map((card: any, card_index: number) => {
                      return <Col span={6} key={card_index}>
                        <div className='card' onClick={() => handleClick(card.url)}>
                          <div title={card.name} className='card-info'>
                            <img src={card.imgUrl} alt={card.name} width={32} />
                            <div className='info'>
                              <div className='name'>{card.name}</div>
                              <div title={card.description} className='desc'>{card.description}</div>
                            </div>
                          </div>
                          <Button onClick={(e) => {
                            if (card.status == 'done') {
                              e.stopPropagation()
                              handleClick(card.url)
                            } else {
                              handleInstall(e, card)
                            }
                          }} type='primary'>{card.status === 'done' ? t('查看') : t('获取')}</Button>
                        </div>
                      </Col>
                    })
                  }
                </Row>
              </div>
            })
          }
        </div>
      </div>
    </div>
  );
}

export default App;
